var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('path',{attrs:{"d":"M11.5 10.8l4.35 4.35a.5.5 0 1 1-.7.7l-4.35-4.34a6.54 6.54 0 1 1 .7-.7zm-1-.37a5.54 5.54 0 1 0-7.9-7.77 5.54 5.54 0 0 0 7.9 7.77z","fill-rule":"evenodd"}})])}
var staticRenderFns = []

export { render, staticRenderFns }